/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CrownIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M13.076 6.315a1.483 1.483 0 0 0-.832-2.715 1.485 1.485 0 0 0-.855 2.7l-.475.962-2.862 5.63a.5.5 0 0 1-.708.199l-3.301-2.033a1.485 1.485 0 1 0-1.451.88l1.743 7.952a.5.5 0 0 0 .488.393H19.33a.5.5 0 0 0 .486-.38l1.984-8.042a1.486 1.486 0 1 0-1.793-.703l-2.957 1.913a.5.5 0 0 1-.72-.198z" clipRule="evenodd" /></svg>;
};
export default CrownIcon;